import { internal, template } from '../../vendor/elix.js';

function ThemedInputMixin(Base) {

  return class ThemedInput extends Base {

    get [internal.template]() {

      const innerSelector = this.innerSelector || '#inner';

      return template.concat(

        super[internal.template],

        template.html`

          <style>

            :host {
              display: inline-block;
            }

            ${innerSelector} {
              -webkit-appearance: none;
              background-color: var(--tp-themed-input-mixin-background-color);
              box-sizing: border-box;
              caret-color: var(--tp-themed-input-mixin-caret-color);
              color: var(--tp-themed-input-mixin-font-color);
              font-family: var(--tp-themed-input-mixin-font-family);
              font-size: var(--tp-themed-input-mixin-font-size);
              line-height: normal;
              width: 100%;
            }

            ${innerSelector}::placeholder {
              color: var(--tp-themed-input-mixin-placeholder-font-color);
              font-family: var(--tp-themed-input-mixin-placeholder-font-family);
              font-size: var(--tp-themed-input-mixin-placeholder-font-size);
            }

            .inputStateContainer.disabled ${innerSelector} {
              color: var(--tp-themed-input-mixin-font-color-disabled);
            }

            .inputStateContainer:not(.disabled):not(.error):hover ${innerSelector} {
              color: var(--tp-themed-input-mixin-font-color-hover);
            }

            .inputStateContainer:not(.disabled):not(.error) ${innerSelector}:focus {
              color: var(--tp-themed-input-mixin-font-color-focused);
            }

            .inputStateContainer.error ${innerSelector} {
              caret-color: var(--tp-themed-input-mixin-caret-color-error);
              color: var(--tp-themed-input-mixin-font-color-error);
            }

          </style>
        `
      );

    }

  }

}

export default ThemedInputMixin;
